import React, { useState, useEffect, useRef } from "react";
import check from "../../assets/Images/check.png";

import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFintechLayouts } from "../../services/AsaApiServices";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
const PlanCancelled = () => {
  const { t } = useTranslation();
  const imgBoxRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const headTextRef = useRef<HTMLImageElement>(null);
  const fintechLaoyut = useFintechLayouts();
  const [displayText, setDisplayText] = useState(""); // Initially empty
  const [animateDone, setAnimateDone] = useState(false); // State for animation (kept for any conditional UI)
  const [showMessage, setShowMessage] = useState(false); // State to control message visibility
  const location = useLocation();
  const { state: navigatestate } = location;
  const cancelCode = navigatestate?.code;
  const navigate = useNavigate();
  // grow + swap animation using Web Animations API
  const animateGrowElement = (box: HTMLDivElement | null, img: HTMLImageElement | null) => {
    if (!box) return;

    // cancel any running animations
    box.getAnimations().forEach(a => a.cancel());
    if (img) img.getAnimations().forEach(a => a.cancel());
    if( headTextRef.current) headTextRef.current.getAnimations().forEach(a => a.cancel());  
    // save previous inline transform-origin so we can restore later
    const prevTransformOrigin = box.style.getPropertyValue("transform-origin");

    // ensure centered transform origin
    box.style.transformOrigin = "50% 50%";

    // grow (scale) animation
    const grow = box.animate(
      [
        { transform: "scale(1) ", opacity: 0 },
        { transform: "scale(1.8) ", opacity: 1 },
       
      ],
      {
        duration: 1000,
        easing: "cubic-bezier(0.2,0.05,0.9,1)",
        fill: "forwards",
      }
    );

    grow.onfinish = () => {
      // restore transform-origin after grow
      if (prevTransformOrigin) box.style.setProperty("transform-origin", prevTransformOrigin);
      else box.style.removeProperty("transform-origin");
      const unGrow = box.animate(
        [
          { transform: "scale(1.8) ", opacity: 1 },
          { transform: "scale(1) ", opacity: 1 },
         
        ],
        {
          duration: 500,
          easing: "cubic-bezier(0.2,0.05,0.9,1)",
          fill: "forwards",
        }
        
      );
      unGrow.onfinish = () => {
        // after un-grow, swap positions
       
          setTimeout(() => {
           setDisplayText(t("subscriptionCancelled"));
           swapPositions(box, headTextRef.current);
        }, 120);
      };
      

    };

    grow.oncancel = () => {
      if (prevTransformOrigin) box.style.setProperty("transform-origin", prevTransformOrigin);
      else box.style.removeProperty("transform-origin");
    };
  };

  // Swap positions: container moves right, image moves left, then return
  const swapPositions = (box: HTMLDivElement, img: HTMLImageElement | null) => {
    const distance = 80; // px to move, adjust as needed
    // cancel previous
    const boxAnim = box.animate(
      [
        { transform: "translateY(0px)" },
        { transform: `translateY(-${distance}px)` },

      ],
      {
        duration: 900,
        easing: "ease-in-out",
        fill: "forwards",
      }
    );

    let imgAnim: Animation | null = null;
    if (img) {
      imgAnim = img.animate(
        [
          { transform: "translateY(0px)" },
          { transform: `translateY(${distance}px) scale(0.95)` },

        ],
        {
          duration: 900,
          easing: "ease-in-out",
          fill: "forwards",
        }
      );
    }

    // when swap finishes restore inline styles and update state
    boxAnim.onfinish = () => {
      box.style.transform = ""; // clear inline transform
      if (img) img.style.transform = "";
      setTimeout(() => setShowMessage(true), 800);
    };

    boxAnim.oncancel = () => {
      box.style.transform = "";
      if (img) img.style.transform = "";
    };
  };

  useEffect(() => {
    // sequence: show "DONE", run grow+swap
    AnalyticsService.track("Plan Cancelled Viewed", AnalyticsAction.View, AnalyticsFeature.Payment);
    setDisplayText(t("done"));
    animateGrowElement(imgBoxRef.current, imgRef.current);

    // cleanup not strictly necessary for WAAPI animations because we cancel before starting new ones,
    // but keep as good practice if timeouts added later.
    return () => {
      imgBoxRef.current?.getAnimations().forEach(a => a.cancel());
      imgRef.current?.getAnimations().forEach(a => a.cancel());
      headTextRef.current?.getAnimations().forEach(a => a.cancel());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen items-center flex-col flex-grow bg-gradient-to-b from-[#705AE2] to-[#705AE2]"
      style={fintechLaoyut?.backGroundStyleFullScreen}
    >

        <div ref={headTextRef} className="flex h-1/3">
          
        </div>
      <div className="flex flex-col ">  
        <div ref={headTextRef} className="flex mb-4 text-white text-center font-poppins text-2xl font-bold leading-8">
          {displayText}
        </div>
      

        <div
          ref={imgBoxRef}
          className="flex justify-center items-center mt-4"
        >
          <img
            ref={imgRef}
            src={check}
            alt={t("successIconAlt")}
            width={80}
            height={80}
          />
        </div>
      </div>
      {showMessage && (
        <>
          <div className="flex text-white text-center font-poppins text-base font-medium leading-8">
            {t("notBilled") }
          </div>
          <div className="mb-10 flex-1 flex text-white uppercase text-center font-poppins text-base font-medium leading-8 items-end"
            onClick={() => navigate("/cancelled",{ state: { code:cancelCode } })}
          >
            {t("close") }
          </div>
        </>
      )}

    </div>
  );
};

export default PlanCancelled;
